import _ from 'lodash';

import Megaphone from './Megaphone';
import { isProduction } from '@zapier/common-utils';

function getReducerName() {
  const stack = new Error().stack;
  // In webpack, each module has a `parents`
  // property for all the modules which
  // import it. Flow doesn't know that.
  // @ts-ignore
  return (module.parents || []).find(parent =>
    stack.includes(parent) ? parent : null
  );
}

const warnOnReferenceOnlyStateChanges = isProduction()
  ? _.noop
  : (oldState, newState, reducerName, actionType) => {
      const isReferenceOnlyStateChange =
        newState !== oldState && _.isEqual(newState, oldState);
      const reducerLabel = _.isEmpty(reducerName)
        ? 'a reducer'
        : `${reducerName} reducer`;
      if (isReferenceOnlyStateChange) {
        Megaphone.alert({
          message: `
          Reference-only change in ${reducerLabel} when handling ${actionType}.
          This may cause needless re-rendering, thus degrading the user experience.`,
          stack: new Error().stack,
        });
      }
    };

function createReducer(handlers, initialState) {
  const reducerName = getReducerName();

  return (state = initialState, action = undefined) => {
    let newState;
    if (handlers[action.type]) {
      newState = handlers[action.type](state, action);
    }
    if (newState) {
      warnOnReferenceOnlyStateChanges(
        state,
        newState,
        reducerName,
        action.type
      );
      return newState;
    }
    return state;
  };
}

export default createReducer;
